import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OverlaysService } from 'src/app/services/overlays.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorsInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (environment.warMode && localStorage.getItem('[merlin] warMode') !== 'syntonize')
          this.router.navigate([''], { replaceUrl: true });
        if (err.status === 200) {
          return next.handle(request);
        }

        const error = err?.error?.message || err?.error?.detail || err?.error;
        //this.overlaysService.presentInfoAlert(error || 'ERROR', 'ALERTS.ERROR');

        return throwError(error);
      })
    );
  }
}
